module.exports = __webpack_public_path__ + "static/media/Right AP Z2.add39db3.png";